var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.upgrade)?_c('v-btn',{staticClass:"header-btn fs-16",attrs:{"color":"mainRed","data-test":"upgrade_workspace_category_button","dark":"","rounded":""},on:{"click":_vm.getUpgradeLink}},[_vm._v(" Upgrade ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }